import { ACTIONS } from "../../../Models/ENUM";
import CONQUER from "../../CONQUER";
import AvatarInstance from "../../AVATAR/AvatarInstance";
import LOG, { log } from "../../../UTIL/LOG";
import Cue from "../../../UTIL/Instances/Cue";
import AVATAR from "../../../Core/USER/AVATAR/AVATAR";
import ARRAY from "../../../UTIL/ARRAY";
import GameInstance from "../GameInstance";

class Rivals 
{
  private gameInstance  : GameInstance;
  private conquer       : CONQUER;
  public RIVAL          : any | AvatarInstance;

  private friendCue     : Cue = new Cue( true );
  private botsCue       : Cue = new Cue( true );
  private counter       : number = 0;
 
  public constructor( gameInstance : GameInstance ) 
  {
    this.gameInstance   = gameInstance;
    this.conquer        = gameInstance.conquer;
  }

  public async init() : Promise<any> 
  {
   // let timed = LOG.timer(); 
    let bots = await this.conquer.Bots.get();

  //  log("Rival GOT BOTS", timed() );

    this.botsCue.copy( bots );

   // timed = LOG.timer();
    let friends = await this.conquer.Friends.get();

   // log("Rival GOT FRIENDS", timed() );
    
    for( let n in friends ) this.friendCue.push( friends[n].avatarInstance );
 
    return Promise.resolve();
  }

  /*=============== 


  GET


  ================*/

  public get( amount : number = 1 )
  {
    // TODO: matchmaking, balance friends and strangers

    let output : any = [];
 
    /* // disable matching with friends for now
    
    while( output.length < amount )
    {
      let friend = this.friendCue.get();

      if( !friend || output.includes( friend ) ) break;

      output.push( friend );
    }*/
  
    while( output.length < amount ) ARRAY.pushUnique( output, this.botsCue.get() );
 
    return output;
  }

  public getNext()
  {
    // TODO: matchmaking, balance friends and strangers

    // Note, cue.getNext will be empty when it reaches the end of the cue

    if( ++this.counter > 3 ) this.counter = 0;

    if( !this.counter ) return null;
 
    return this.friendCue.getNext() || this.botsCue.getNext();
 
  }

  /*=============== 


  SET
 

  ================*/
 
  public set( avatarID?:string, data?:any ) : AvatarInstance
  {
    if( this.RIVAL && avatarID == this.RIVAL.avatarID ) return this.RIVAL;

    let avatarInstance : AvatarInstance;

    if( !avatarID )
    {
      avatarInstance = this.get()[0];
    }else{
      avatarInstance = this.conquer.Avatars.data[ avatarID ]
    }

    this.RIVAL = avatarInstance;

    return this.RIVAL;
  }

  /*=============== 


  REMOVE
 

  ================*/

  public remove()
  {
    this.RIVAL = null;
  }

  public getRival()
  {
    return this.RIVAL || this.set();
  }

 
}

export default Rivals;
